export default __webpack_public_path__ + "static/media/link-drop-background.7d06707f.svg";